import type { EventSection, FamilyEvent, MediaItem, PresentationSlide } from "../types";

export const demoEvents: FamilyEvent[] = [
  {
    id: "demo-yaeyama",
    title: "石垣・竹富・西表 3島周遊バカンス",
    slug: "yaeyama-2026",
    description:
      "4泊5日で八重山諸島を満喫。ダイビング、水牛車、カヌー、洞窟探検など、家族全員で楽しむアクティブな旅。",
    location: "沖縄県 八重山諸島",
    icon: "waves",
    status: "upcoming",
    start_date: "2026-02-20",
    end_date: "2026-02-24",
    cover_image_url:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1400&q=80",
    is_published: true,
    sort_order: 10
  }
];

export const demoSections: EventSection[] = [
  {
    id: "demo-section-1",
    event_id: "demo-yaeyama",
    title: "旅の概要",
    body: "予定、旅程、写真、動画をこのページに集約します。管理画面からイベントを追加すると、同じデザインで公開ページに反映されます。",
    sort_order: 10
  }
];

export const demoMedia: MediaItem[] = [
  {
    id: "demo-media-1",
    event_id: "demo-yaeyama",
    type: "youtube",
    title: "紹介動画",
    url: "https://www.youtube.com/watch?v=jNQXAC9IVRw",
    caption: "YouTube限定公開URLを管理画面に登録する想定です。埋め込み再生できない動画はYouTubeで開けます。",
    sort_order: 10
  }
];

export const demoPresentationSlides: PresentationSlide[] = [
  {
    id: "demo-presentation-slide-1",
    event_id: "demo-yaeyama",
    section_kind: "cover",
    title: "八重山ブルーへ飛び込む5日間",
    body: "石垣島を拠点に、竹富島の白砂、西表島のマングローブ、家族で挑む海と森の体験を一つの物語にまとめます。",
    badge: "Family Trip",
    image_prompt:
      "A bright family travel presentation cover showing Ishigaki island turquoise sea, coral sand, and tropical sunlight, editorial photography style",
    image_url:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1400&q=80",
    sort_order: 10,
    generation_metadata: {
      source: "demo",
      model: "demo-fallback",
      generated_at: "2026-04-29T00:00:00.000Z"
    }
  },
  {
    id: "demo-presentation-slide-2",
    event_id: "demo-yaeyama",
    section_kind: "itinerary",
    title: "島ごとに表情が変わる旅程",
    body: "到着日は石垣島で海風に慣れ、竹富島では水牛車と集落散策、西表島ではカヌーと洞窟探検へ。毎日違う景色を家族の記憶に残します。",
    badge: "Itinerary",
    image_prompt:
      "A clean travel story image of island hopping in Yaeyama, ferry wake, lush jungle, and traditional Okinawan village streets",
    image_url:
      "https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?auto=format&fit=crop&w=1400&q=80",
    sort_order: 20,
    generation_metadata: {
      source: "demo",
      model: "demo-fallback",
      generated_at: "2026-04-29T00:00:00.000Z"
    }
  },
  {
    id: "demo-presentation-slide-3",
    event_id: "demo-yaeyama",
    section_kind: "summary",
    title: "旅のあとに見返したくなる一冊",
    body: "写真、動画、旅程メモをスライドとして保存して、公開ページからいつでも振り返れる家族向けのスクロールストーリーにします。",
    badge: "Memories",
    image_prompt:
      "A warm family travel memory scene with printed photos, a beach notebook, shells, and soft afternoon window light",
    image_url:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
    sort_order: 30,
    generation_metadata: {
      source: "demo",
      model: "demo-fallback",
      generated_at: "2026-04-29T00:00:00.000Z"
    }
  }
];
